"use client";
import React, { useContext, useState } from "react";
import Link from "next/link";
import HeaderLogo from "../../../public/assets/img/logo/logo.png";
import HeaderLogoText from "../../../public/assets/img/logo/logo-text.png";
import Image from "next/image";
import useScrollDirection from "@/hooks/sticky-header";
import { AppContext } from "@/contextApi/AppProvider";
import { AppContextType } from "@/interFace/general";
import MemoMenu from "./MemoMenu";
import MemoMobileMenu from "./component/MemoMobileMenu";
import { getLink, Routes } from "@/constants";
import {
  useUniqueProductCount,
  useUniqueWishlstCount,
} from "@/hooks/useCartQuantity";
import { Culture } from "@/components/languages/CulturesV2";

const MemoHeader = () => {
  const scrollDirection = useScrollDirection(null);
  const { toggleSideMenu, sideMenuOpen, locale, currentUser, userInfo } = useContext(
    AppContext
  ) as AppContextType;
  const [cartOpen, setCartOpen] = useState(false);
  const cartQuantity = useUniqueProductCount();
  const resolvedWorkspace = userInfo.activeWorkspace ?? userInfo.defaultWorkspace;
  const logoTargetUrl = !currentUser?.uid
    ? getLink(locale, Routes.HOMEPAGE)
    : resolvedWorkspace === "tutor"
      ? getLink(locale, Routes.TUTORS_ROOT)
      : resolvedWorkspace === "parent"
        ? getLink(locale, Routes.PARENTS_ROOT)
        : userInfo.activeRole === "tutor" || userInfo.roles.includes("tutor")
          ? getLink(locale, Routes.TUTORS_ROOT)
          : userInfo.activeRole === "parent" || userInfo.roles.includes("parent")
            ? getLink(locale, Routes.PARENTS_ROOT)
            : getLink(locale, Routes.DASHBOARD_COURSES);

  return (
    <>
      <header>
        <div
          id="header-sticky"
          className={`header__area header__transparent header__padding ${
            scrollDirection === "down" ? "sticky" : ""
          }`}
        >
          <div className="container-fluid">
            <div className="row align-items-center">
              <div className="col-xxl-3 col-xl-3 col-lg-4 col-md-2 col-sm-4 col-6">
                <div className="header__left d-flex">
                  <div>
                    <div className="logo" style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                      <Link href={logoTargetUrl}>
                        <Image
                          src={HeaderLogo}
                          style={{ width: "72px", height: "auto", minWidth: "72px" }}
                          alt="logo"
                        />
                      </Link>
                      <Link href={logoTargetUrl}>
                        <Image
                          src={HeaderLogoText}
                          style={{ width: "148px", height: "auto", minWidth: "148px" }}
                          alt="logo text"
                        />
                      </Link>
                    </div>
                    <div className="d-xl-none" style={{ marginTop: "10px" }}>
                      <Culture />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xxl-9 col-xl-9 col-lg-8 col-md-10 col-sm-8 col-6">
                <div className="header__left d-flex justify-content-end align-items-center">
                  {/* I have removed main-menu with 'd-none d-xl-block' to show MemoMenu in small screen for simplicity */}
                  <div className="main-menu d-none d-xl-block">
                    <nav id="mobile-menu">
                      <ul>
                        <MemoMenu />
                      </ul>
                    </nav>
                  </div>
                  <div className="sidebar__menu d-xl-none">
                    <div
                      onClick={toggleSideMenu}
                      className="sidebar-toggle-btn ml-30"
                      id="sidebar-toggle"
                    >
                      <span className="line"></span>
                      <span className="line"></span>
                      <span className="line"></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>

      <div
        onClick={() => setCartOpen(false)}
        className={cartOpen ? "body-overlay opened" : "body-overlay"}
      ></div>
      <MemoMobileMenu />
      <div
        onClick={toggleSideMenu}
        className={sideMenuOpen ? "body-overlay opened" : "body-overlay"}
      ></div>
    </>
  );
};

export default MemoHeader;
